import 'babel-polyfill';
require('es6-promise').polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
Vue.config.productionTip = false
import 'animate.css';
//element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//想改变this.$route.query中的数据（就是地址栏中的参数）
// this.$router.push({
// query:merge(this.$route.query,{'id':'630'})
// })
// 国际化相关
import i18n from './i18n';
import merge from 'webpack-merge';
// 图片预览
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer)
// swiper相关
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper)
// seo相关
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo)
import {
  Swipe,
  SwipeItem
} from 'vant';
Vue.use(Swipe).use(SwipeItem);
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})

import componentsList from './plugins/componentsRegister'; // 自动引入处理组件插件
Vue.use(componentsList);
// =================全局变量======================
Vue.prototype.$global_imgurl = 'https://images.tianyiwangxiao.com/' // img链接地址挂载到 Vue 实例上
Vue.prototype.$global_pdfurl = 'https://tywx-files.oss-cn-beijing.aliyuncs.com/' // pdf链接地址挂载到 Vue 实例上
//Vue.prototype.BASE_URL = process.env.NODE_ENV;
Vue.prototype.BASE_URL = '/api';
new Vue({
  el: '#app',
  router,
  store,
  i18n, //很重要，别忘记
  components: {
    App
  },
  render: h => h(App),
  mounted() {}
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js